export default class Video {
    constructor(id, title) {
        this.id = id;
        this.title = title;
    }

    // region GETTERS
    getThumbnailSrc() {
        return `https://img.youtube.com/vi/${this.id}/sddefault.jpg`;
    }

    // endregion GETTERS
}
